/* eslint-disable no-restricted-imports */
import { Link as AnvilLink, RawLink as AnvilRawLink } from '@dittolive/anvil'
import React, { ComponentProps, forwardRef } from 'react'
import { NavLink } from 'react-router-dom'

type RawLinkProps = ComponentProps<typeof AnvilRawLink> & {
  onMouseEnter?: React.MouseEventHandler<HTMLAnchorElement>
}

/**
 * Router-aware versions of the Anvil link components. Anvil is router
 * agnostic: given `to` without `as`, it renders a plain anchor, which
 * full-page-reloads the SPA and resolves relative paths against the URL
 * instead of the route tree. These wrappers default `as` to NavLink
 * whenever `to` is set, matching the pre-Anvil portal Link behavior.
 *
 * Always import Link and RawLink from here instead of '@dittolive/anvil'
 * (enforced by the no-restricted-imports lint rule).
 */
export const Link = forwardRef<HTMLAnchorElement, RawLinkProps>(
  ({ as, ...props }, ref) => (
    <AnvilLink
      ref={ref}
      as={as ?? (props.to ? NavLink : undefined)}
      {...props}
    />
  ),
)
Link.displayName = 'Link'

export const RawLink = forwardRef<HTMLAnchorElement, RawLinkProps>(
  ({ as, ...props }, ref) => (
    <AnvilRawLink
      ref={ref}
      as={as ?? (props.to ? NavLink : undefined)}
      {...props}
    />
  ),
)
RawLink.displayName = 'RawLink'
